import styles from './ADSPlaygroundActions.module.scss'
import AIToolsSelector from "./Component/AIToolsSelector";
import Marketplace from "./Component/Marketplace";
import {useADSContext} from "../../../../../../../../context/ADSProvider";
import ImageEditorTrigger from "./Component/ImageEditorTrigger";
import {useAIToolsContext} from "../../../../../../../../context/AIToolsProvider";
import DetectFaceTrigger from "./Component/DetectFaceTrigger";
import {useImageEditorContext} from "../../../../../../../../context/ImageEditorProvider";

const ADSPlaygroundActions = () => {
  const {selectedProduct} = useADSContext();
  const {selectedAITools} = useAIToolsContext();
  const {isEditingImage} = useImageEditorContext();

  const hasSelectedProduct = !!selectedProduct.id
  const disableMarketplace = !!selectedAITools || isEditingImage

  return (
    <div className={styles.wrapper}>
      <AIToolsSelector/>
      {hasSelectedProduct && (
        <>
          <ImageEditorTrigger/>
          <Marketplace disabled={disableMarketplace} />
        </>
      )}
      <DetectFaceTrigger/>
    </div>
  );
};

export default ADSPlaygroundActions;
